import request from '@/utils/fetch'

// 查询接收列表
export function getUserMessagesList (data) {
  return request({
    url: '/messageInfo/getUserMessagesList',
    method: 'post',
    data
  })
}

// 查询未读消息 数量
export function getMessagesNum () {
  return request({
    url: '/messageInfo/getMessagesNum',
    method: 'get'
  })
}

// 删除接收消息
export function deleteUserMessage (data) {
  return request({
    url: '/messageInfo/deleteUserMessage',
    method: 'delete',
    data
  })
}

// 标为已读
export function updateMessageState (data) {
  return request({
    url: '/messageInfo/updateMessageState',
    method: 'put',
    data
  })
}

// 提醒看板弹框接口，点击立即处理，跳到退费申请页面
export function getPendingApprovalRefund () {
  return request({
    url: '/refund/getPendingApprovalRefund',
    method: 'get'
  })
}

// 查询预算待审批总数
export function getMyWaitFlowBudget () {
  return request({
    url: '/budget/getMyWaitFlowBudget',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/homePage/api_notification.js